import type { SiteConfig } from '@/types'

import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: 'WebReplica AI',
    description: 'Analyze any public website with a real browser and rebuild it as an editable React, Vite and Tailwind project you can preview, refine with AI and download.',
    url: getOrigin()
}

export const PROJECT_SECTIONS = [
    { id: 'overview', label: 'Overview' },
    { id: 'pages', label: 'Pages' },
    { id: 'screenshots', label: 'Screenshots' },
    { id: 'recording', label: 'Screen Recording' },
    { id: 'design', label: 'Design Analysis' },
    { id: 'assets', label: 'Assets' },
    { id: 'code', label: 'Code Editor' },
    { id: 'preview', label: 'Live Preview' },
    { id: 'export', label: 'Build & Export' }
] as const

export type ProjectSectionId = typeof PROJECT_SECTIONS[number]['id']

export const STEP_LABELS = {
    prepare: 'Safety checks',
    crawl: 'Browser capture',
    analyze: 'Design analysis',
    generate: 'Code generation',
    validate: 'Build checks'
} as const

export const EDIT_SUGGESTIONS = [
    'Change the primary color to blue',
    'Make the website feel more premium',
    'Improve the mobile layout',
    'Add a new FAQ page linked in the navigation',
    'Fix any broken navigation links',
    'Replace the logo with the image I attached'
]
